// extracted by mini-css-extract-plugin
module.exports = {"infinitePagination":"antd-pro-ui-infinite-pagination-index-infinitePagination","pageSizeSelect":"antd-pro-ui-infinite-pagination-index-pageSizeSelect"};